import React from 'react';
import {ArrowRight} from 'lucide-react';
import {FlowStepItem} from '../../pages/site/site.types';
import styles from './styles/HowItWorksFlow.module.css';

interface HowItWorksFlowProps {
    steps: FlowStepItem[];
    columns?: number;
}

const HowItWorksFlow: React.FC<HowItWorksFlowProps> = ({steps, columns}) => (
    <div
        className={styles.grid}
        style={columns ? {gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`} : undefined}
    >
        {steps.map((step, index) => (
            <article className={`site-card ${styles.card}`} key={step.title}>
                <span className={styles.index}>0{index + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                {step.detail ? <small>{step.detail}</small> : null}
                {index < steps.length - 1 ? <ArrowRight className={styles.arrow} size={18}/> : null}
            </article>
        ))}
    </div>
);

export default HowItWorksFlow;
